import { html } from "lit";
import { getDummyText } from "../../../../utils";

const dummyPageDesc = `Description ${getDummyText(300)}`;

export const dummyPage = {
    category: "Category",
    headline: "Seitentiel Lorem Ipsum Dolor consectetur",
    description: dummyPageDesc,
    url: "#",
};

export const dummyPages = Array(10).fill({ ...dummyPage });

export const TeaserPageTemplate = ({
    category = "Category",
    headline = "Seitentiel Lorem Ipsum Dolor consectetur",
    description = dummyPageDesc,
    url = "#",
}) => html`
    <ux-iws-link-wrapper class="ux-iws-teaser-page">
        <div class="ux-iws-teaser-page__container">
            <div class="ux-iws-teaser-page__inner">
                <div class="ux-iws-teaser-page__header">
                    <span class="ux-tag ux-iws-teaser-page__tag">
                        ${category}
                    </span>
                    <p class="ux-iws-teaser-page__title ux-text-title-teaser">
                        <a class="ux-iws-teaser-page__link" href="${url}">
                            ${headline}
                        </a>
                    </p>
                </div>
                <ux-text-lines-limit
                    text-lines-s="3"
                    text-lines-m="3"
                    text-lines-l="3"
                    text-lines-xl="2"
                >
                    <p class="ux-iws-teaser-page__description">
                        ${description}
                    </p>
                </ux-text-lines-limit>
            </div>
            <div class="ux-iws-teaser-page__link">
                <a
                    class="ux-button ux-button--icon-only"
                    href="#"
                    aria-label="Lorem Ipsum"
                    role="button"
                >
                    <ux-icon name="chevron-right"></ux-icon>
                </a>
            </div>
        </div>
    </ux-iws-link-wrapper>
`;

export const TeaserPageListTemplate = () => html`
    <div class="ux-col-12">
        ${dummyPages.map((tile) => TeaserPageTemplate(tile))}
    </div>
`;
